import { Box } from '@mui/material';
import React from 'react';
import './footer.scss';

const Footer = () => {
    return (
      <Box textAlign="center" className="footer w-full">
        <small>
          &copy; {new Date().getFullYear()}. Khurshida Jahan Meem. All Rights Reserved.
        </small>
      </Box>
    );
};

export default Footer;